import { render } from "./MsAccess.vue?vue&type=template&id=1e31959c&scoped=true"
import script from "./MsAccess.vue?vue&type=script&lang=js"
export * from "./MsAccess.vue?vue&type=script&lang=js"

import "./MsAccess.vue?vue&type=style&index=0&id=1e31959c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e31959c"]])

export default __exports__